import { useDashboardFilters } from './useDashboardFilters'
import { SelectFilter } from './SelectFilter'

/**
 * The header's view mode, a chip at its far right: what every section shows by default (e.g. the
 * year to date, or monthly actuals). Choosing one resets the sections'
 * own timeframe and range. Renders nothing for a dashboard without view modes.
 */
export const ViewModeSelect = () => {
  const { viewModes, viewMode, setViewMode } = useDashboardFilters()
  if (!viewMode) return null
  return (
    <SelectFilter
      label='View:'
      hideLabel
      options={viewModes.map(mode => ({ value: mode.id, label: mode.label }))}
      value={viewMode.id}
      onChange={setViewMode}
      align='end'
    />
  )
}
